import React from 'react';
import { EntryType } from 'lib/models';
import { FaFileAlt, FaFolder, FaCalendarAlt, FaInbox } from 'react-icons/fa';

interface WidgetSelectTabProps { }

function WidgetSelectTab(props: WidgetSelectTabProps) {
  const entryTypes = [
    {
      type: EntryType.TEXT,
      icon: FaFileAlt,
      label: "Text Entry",
      description: "A simple text entry for notes and documents"
    },
    {
      type: EntryType.WORKSPACE,
      icon: FaFolder,
      label: "Workspace",
      description: "A container for organizing other entries"
    },
    {
      type: EntryType.JOURNAL,
      icon: FaCalendarAlt,
      label: "Journal",
      description: "A dated entry for daily notes and reflections"
    },
    {
      type: EntryType.BUCKET,
      icon: FaInbox,
      label: "Bucket",
      description: "A collection of related entries"
    }
  ];

  const handleDragStart = (e: React.DragEvent, entryType: EntryType) => {
    e.dataTransfer.setData('text/plain', entryType);
    const icon = e.currentTarget.querySelector('svg');
    if (icon) {
      const dragImage = icon.cloneNode(true) as SVGElement;
      dragImage.style.width = '32px';
      dragImage.style.height = '32px';
      dragImage.style.color = 'var(--palette-4)';
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(dragImage, 16, 16);
      setTimeout(() => document.body.removeChild(dragImage), 0);
    }
  };

  return (
    <div className="grid gap-4 grid-cols-2 p-2">
      {entryTypes.map((entry) => (
        <div
          draggable
          key={`widget-select-${entry.type}`}
          className="flex flex-col items-center p-4 bg-palette-4 rounded-lg hover:bg-palette-3 cursor-move transition-colors"
          onDragStart={(e) => handleDragStart(e, entry.type)}
        >
          <div className="flex w-full items-center justify-center space-x-2">
            <entry.icon className="text-4xl text-palette-1 mb-2" />
            <div className="text-lg font-medium text-palette-1">{entry.label}</div>
          </div>
          <div className="text-sm text-palette-2 text-center">{entry.description}</div>
        </div>
      ))}
    </div>
  );
}

export default WidgetSelectTab;
